import { FC } from 'react';
import AlertDialog from 'components/AlertDialog';
import Typography from '@mui/material/Typography';
import { Disclosure } from 'further-ui/hooks';

type Props = {
  disclosure: Disclosure;
  isSyndicate: boolean;
  onConfirm: (params: { keepDateChange: boolean }) => void;
};

const InvestmentDateChangedWarningModal: FC<Props> = ({
  disclosure,
  isSyndicate,
  onConfirm,
}) => (
  <AlertDialog
    open={disclosure.isOpen}
    title="Changing subscription date"
    content={
      isSyndicate ? (
        <Typography>
          If you proceed, any periodic investor reports generated before the new
          subscription date will no longer display. If the new subscription date
          is in a different tax/calendar year, it may change syndicate reporting
          for this subscription, depending on your firm settings.
        </Typography>
      ) : (
        <Typography>
          If you proceed, any periodic investor reports generated before the new
          subscription date will no longer display, if applicable.
        </Typography>
      )
    }
    size="sm"
    onConfirm={() => onConfirm({ keepDateChange: true })}
    onClose={disclosure.onClose}
    onCancel={() => onConfirm({ keepDateChange: false })}
    btnLabels={{
      cancel: 'Leave date unchanged',
      confirm: 'Update date',
    }}
    cancelBtnProps={{
      color: 'primary',
    }}
  />
);

export default InvestmentDateChangedWarningModal;
